import script from "./TraitShopSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopSearchBar.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopSearchBar.vue?vue&type=style&index=0&id=35f5bac0&lang=scss"

const __exports__ = script;

export default __exports__